<template>
	<core-pagination
		:total="count"
		:pageTotal="pageTotal"
		:perPage="perPage"
		@changePage="changePage"
		:page="page"
	/>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('monsterleads')

export default  {
	props : {
		pageTotal : {
			type    : Number,
			default : 0,
		},
	},
	computed : {
		...mapState([ 'count', 'page' ]),
		...mapGetters([ 'perPage' ]),
		totalPages () {
			return Math.ceil(this.count / this.perPage)
		},
	},
	methods : {
		...mapActions([ 'goToPage' ]),
		changePage (page) {
			if (page <= this.totalPages && 0 < page) {
				this.goToPage({ page })
			}
		},
	},
}
</script>
